export enum TypeBannerByDispatch {
  ModalVideoWhyChoose = 'pochemu-vybirayut-nas-vidio',
}
